import React, { MouseEvent } from 'react';
import classNames from 'classnames';

export const AddButton = ({
  onClick,
  disabled,
  className,
}: {
  onClick?: (e?: MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  className: string;
}) => {
  return (
    <div
      className={classNames(className, {
        [`${className}--disabled`]: disabled,
      })}
      onClick={() => (disabled ? null : onClick?.())}
    >
      + Add Question
    </div>
  );
};
